/**
 * 对数组项逐个进行 upsert 的操作，返回新的数组
 *
 * 仅适用于 object 数组。数组里的空值最后会被去掉
 *
 * @param upsert 有新旧两条数据的时候，如何做合并？默认就取后者，抛弃前者
 */
export default function mergeArray(arr1, arr2, key, upsert) {
    const idIndexMap = {};
    const ans = [];
    const finalUpsert = upsert || ((_, n) => n);
    const procArray = (arr) => {
        arr.forEach((nit) => {
            /* istanbul ignore next */
            if (!nit)
                return;
            const iKey = nit[key];
            if (!iKey)
                return;
            const index = idIndexMap[iKey];
            if (typeof index !== 'number') {
                ans.push(nit);
                idIndexMap[iKey] = ans.length - 1;
            }
            else {
                ans[index] = finalUpsert(ans[index], nit);
            }
        });
    };
    if (arr1)
        procArray(arr1);
    if (arr2)
        procArray(arr2);
    return ans;
}
